import { render } from "./Id.vue?vue&type=template&id=ba7c80e4"
import script from "./Id.vue?vue&type=script&lang=js"
export * from "./Id.vue?vue&type=script&lang=js"

import "./Id.vue?vue&type=style&index=0&id=ba7c80e4&lang=less"
script.render = render

export default script